module.exports = __webpack_public_path__ + "img/old_2_thumb.4acabd3e.jpg";